/* eslint-disable no-unused-expressions */
import React from 'react';
import initReactFastclick from 'react-fastclick';
import ReactDOM from 'react-dom';
import './index.module.less';
// import VConsole from 'vconsole';
import App from './App';

import './public/js/amfe';

// process.env.REACT_APP_API_ENV !== 'production' && new VConsole();
// eslint-disable-next-line no-new
// new VConsole();
initReactFastclick();

ReactDOM.render(<App />, document.getElementById('root'));
